import { useState, useEffect } from 'react';

const navItems = [
  { label: '话题热榜', href: '#topics' },
  { label: '视频爆料', href: '#media' },
  { label: '深度实锤', href: '#cards' },
  { label: '吃瓜评论', href: '#comments' },
  { label: '投稿爆料', href: '#contact' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNav = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50 border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="mx-auto px-4 md:px-6 h-[72px] flex items-center justify-between">
        <a
          href="#hero"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}
          className="flex items-center gap-2 cursor-pointer"
        >
          <span className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
            <i className="ri-fire-fill text-background-50 text-lg"></i>
          </span>
          <span
            className={`text-xl font-heading font-bold whitespace-nowrap ${
              scrolled ? 'text-foreground-900' : 'text-background-50'
            }`}
          >
            黑料吃瓜爆料
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-7">
          <a
            href="#hero"
            onClick={(e) => {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
            className={`text-sm font-medium whitespace-nowrap transition-colors ${
              scrolled
                ? 'text-foreground-700 hover:text-primary-500'
                : 'text-background-50/90 hover:text-background-50'
            }`}
          >
            首页
          </a>
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => {
                e.preventDefault();
                handleNav(item.href);
              }}
              className={`text-sm font-medium whitespace-nowrap transition-colors ${
                scrolled
                  ? 'text-foreground-700 hover:text-primary-500'
                  : 'text-background-50/90 hover:text-background-50'
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className={`md:hidden w-9 h-9 flex items-center justify-center rounded-md transition-colors ${
            scrolled
              ? 'text-foreground-700 hover:bg-background-200'
              : 'text-background-50 hover:bg-white/10'
          }`}
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-4">
          <a
            href="#hero"
            onClick={(e) => {
              e.preventDefault();
              setMobileOpen(false);
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
            className="block py-3 text-sm font-medium text-foreground-700 border-b border-background-200"
          >
            首页
          </a>
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => {
                e.preventDefault();
                handleNav(item.href);
              }}
              className="block py-3 text-sm font-medium text-foreground-700 border-b border-background-200"
            >
              {item.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
}